/** Shared styles for sidebar collection table links: larger hit area + clear current-route state. */

type CollectionRowAccent = "green" | "blue"

const collectionRowActiveClasses: Record<CollectionRowAccent, string> = {
  green:
    "border-green-600 bg-green-100 shadow-[inset_0_0_0_1px_rgba(22,163,74,0.18)] dark:border-green-400 dark:bg-green-950/60 dark:shadow-[inset_0_0_0_1px_rgba(74,222,128,0.22)]",
  blue: "border-blue-600 bg-blue-100 shadow-[inset_0_0_0_1px_rgba(37,99,235,0.18)] dark:border-blue-400 dark:bg-blue-950/60 dark:shadow-[inset_0_0_0_1px_rgba(96,165,250,0.22)]",
}

export function collectionRowShellClasses(args: {
  routeActive: boolean
  keyboardSelected: boolean
  listNoView: boolean
  accent?: CollectionRowAccent
}): string {
  const { routeActive, keyboardSelected, listNoView, accent = "blue" } = args
  const base =
    "group flex items-center justify-between gap-2 w-full text-left rounded-lg transition-colors border-l-2"
  const active = collectionRowActiveClasses[accent]
  const keyboardOnly =
    !routeActive && keyboardSelected
      ? "border-transparent bg-gray-100 dark:bg-gray-700/70 ring-1 ring-inset ring-gray-200/90 dark:ring-gray-600/80"
      : ""
  const idle =
    !routeActive && !keyboardSelected
      ? accent === "blue"
        ? "border-transparent hover:bg-blue-50/90 dark:hover:bg-blue-900/35"
        : "border-transparent hover:bg-green-50/90 dark:hover:bg-green-900/35"
      : ""
  const blocked = listNoView ? " opacity-60 cursor-not-allowed" : ""
  return [base, routeActive ? active : "", keyboardOnly, idle, blocked].filter(Boolean).join(" ")
}

export const collectionRowPaddingComfortable = "py-2.5 px-3 min-h-[2.75rem]"

export const collectionMenuPurpleIconClasses = "text-violet-600 dark:text-violet-400"

export const collectionMenuTrailingIconSlotClass =
  "inline-flex w-3.5 h-3.5 items-center justify-center shrink-0"

export function collectionRowLabelClasses(routeActive: boolean, accent: CollectionRowAccent = "blue"): string {
  if (routeActive) {
    return accent === "green"
      ? "text-sm font-semibold text-green-950 dark:text-green-100 truncate"
      : "text-sm font-semibold text-blue-950 dark:text-blue-100 truncate"
  }
  return "text-sm text-gray-700 dark:text-gray-300 truncate"
}

export function collectionRowIconClasses(
  routeActive: boolean,
  groupHover?: boolean,
  accent: CollectionRowAccent = "blue"
): string {
  const base = "w-4 h-4 shrink-0"
  if (routeActive) {
    return accent === "green"
      ? `${base} text-green-600 dark:text-green-300`
      : `${base} text-blue-600 dark:text-blue-300`
  }
  if (groupHover) {
    return accent === "blue"
      ? `${base} text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-400`
      : `${base} text-gray-500 dark:text-gray-400 group-hover:text-green-600 dark:group-hover:text-green-400`
  }
  return `${base} text-gray-500 dark:text-gray-400`
}
